import { defineMessages } from 'react-intl';

const messages: {
	searchExamplesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchExamplesLabel: {
		id: 'ai-mate.rovo-conversation-search-prompts.search-examples-label',
		defaultMessage: 'Search examples',
		description:
			'Accessible label for the search input in the prompt library. Helps screen reader users understand the purpose of the search field.',
	},
	searchPlaceholder: {
		id: 'ai-mate.rovo-conversation-search-prompts.search-placeholder',
		defaultMessage: 'Search',
		description:
			'Placeholder text displayed in the prompt search input field before the user types anything.',
	},
});

export default messages;
